import { render } from "./Issuance.vue?vue&type=template&id=6b9bde0e&scoped=true"
import script from "./Issuance.vue?vue&type=script&lang=js"
export * from "./Issuance.vue?vue&type=script&lang=js"

import "./Issuance.vue?vue&type=style&index=0&id=6b9bde0e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9bde0e"]])

export default __exports__